import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { Assessment as ReportIcon } from '@mui/icons-material';
import AcsSurveyDialog from './AcsSurveyDialog';

const DeviceReportMenuButton = ({ serial }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [acsOpen, setAcsOpen] = useState(false);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenNeighborReport = () => {
    if (serial) {
      window.open(`/neighbors/${serial}`, '_blank', 'noopener,noreferrer');
    }
    handleCloseMenu();
  };

  const handleOpenTmCandidatesReport = () => {
    if (serial) {
      window.open(`/tm-candidates/${serial}`, '_blank', 'noopener,noreferrer');
    }
    handleCloseMenu();
  };

  if (!serial) {
    return null;
  }

  return (
    <>
      <Tooltip title="Reports">
        <IconButton
          onClick={handleOpenMenu}
          size="small"
          sx={{
            width: '28px',
            height: '28px',
            border: '1px solid',
            borderColor: 'divider',
            '&:hover': {
              borderColor: 'primary.main',
              backgroundColor: 'action.hover',
            },
          }}
        >
          <ReportIcon sx={{ fontSize: '0.875rem' }} />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handleOpenNeighborReport}>
          Neighbor report
        </MenuItem>
        <MenuItem onClick={handleOpenTmCandidatesReport}>
          TM candidates
        </MenuItem>
        <MenuItem onClick={() => { handleCloseMenu(); setAcsOpen(true); }}>
          ACS survey
        </MenuItem>
      </Menu>
      <AcsSurveyDialog open={acsOpen} serial={serial} onClose={() => setAcsOpen(false)} />
    </>
  );
};

export default DeviceReportMenuButton;
